import { type FC, type ReactNode } from "react";

import { LensDiff, LensStatsItem } from "../../lens-stats/components";
import { statValue as statValueClass } from "../../lens-stats/components/LensStats.module.css";

import { StatSkeletonContainer } from "./StatSkeletonContainer";

interface SubTabHeaderProps {
    label: ReactNode;
    statValue: number | string;
    tooltip?: ReactNode;
    diffValue?: string;
    loading?: boolean;
    children?: ReactNode;
    isDifflayoutColumn?: boolean;
}

export const SubTabHeader: FC<SubTabHeaderProps> = ({
    label,
    tooltip,
    statValue,
    diffValue,
    loading = false,
    isDifflayoutColumn = false,
}) => {
    return (
        <LensStatsItem label={label} tooltip={tooltip} show={true}>
            <StatSkeletonContainer loading={loading}>
                <div className={statValueClass}>{statValue}</div>
                <LensDiff isColumn={isDifflayoutColumn} diffValue={diffValue} />
            </StatSkeletonContainer>
        </LensStatsItem>
    );
};
